import { FlyerDetailPage } from "./pages/flyer-detail-page/components/flyer-detail-page/flyer-detail-page.component";
import { PAGES } from "../../../../features/navigation/types/pages.constant";
import { getIdPath } from "../../../../features/navigation/types/pages.functions";
import { FlyerDetailAddPage } from "./pages/flyer-detail-add-page/components/flyer-detail-add-page/flyer-detail-add-page.component";

export const FlyerDetailRoutes = [
  {
    component: FlyerDetailAddPage,
    path: `${getIdPath(`${PAGES.FLYERS.URL}`)}/add-page`,
  },
  {
    component: FlyerDetailPage,
    path: `${getIdPath(`${PAGES.FLYERS.URL}`)}/page/:pageId`,
  },
];
